import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { DataIpAccessRules } from "../../../redux/@types";
import {
  setIsIpAccessRulesForUpdate,
  setIpAccessRulesForUpdate,
  ipAccessRulesChangeModalState,
} from "../../../redux/actions/ipAccessRules.actions";

export const useTableIpAccessRules = () => {
  const dispatch = useAppDispatch();

  const changeIpAccessRulesForUpdate = (val: DataIpAccessRules) => {
    dispatch(setIsIpAccessRulesForUpdate(true));
    dispatch(setIpAccessRulesForUpdate(val));
    dispatch(ipAccessRulesChangeModalState());
  };

  return {
    changeIpAccessRulesForUpdate,
  };
};
